import { Badge } from '@/components/ui/badge';
import { waitingOnLabel, waitingOnVariants } from '@/lib/status';
import type { TrackerWaitingOn } from '@/types/tracker';

export function WaitingOnPill({
  waitingOn,
  companyName,
  className
}: {
  waitingOn?: TrackerWaitingOn | null;
  companyName?: string | null;
  className?: string;
}) {
  if (!waitingOn) return null;
  return (
    <Badge variant={waitingOnVariants[waitingOn]} className={className}>
      Waiting on: {waitingOnLabel(waitingOn, companyName)}
    </Badge>
  );
}
